import HBButton from "@/components/HBButton";
import useAppStore from "@/context/store";
import { BoardPinList } from "@/pageComponents/BoardPinList/PinList";
import {
  organizePinListGuide,
  useNewRegisterGuide,
} from "@/utils/hooks/useNewRegisterGuide";
import Link from "next/link";
import { useEffect, useRef } from "react";
import styles from "./index.module.less";

export default function UnorganizedPinList({
  board,
  showEditBtn = false,
}: {
  board: IBoardInfo;
  showEditBtn?: boolean;
}) {
  const user = useAppStore((state) => state.user);

  const sortBtnRef = useRef<HTMLAnchorElement>(null);
  const { show } = useNewRegisterGuide();
  useEffect(() => {
    if (user && sortBtnRef.current) {
      show("unorganized_pin_list", organizePinListGuide(sortBtnRef));
    }
  }, [user]);

  return (
    <div className={styles.unorganizedContainer}>
      <div className={styles.title}>
        {showEditBtn ? "未整理的采集" : "更多采集"}
        {showEditBtn && (
          <Link
            href={`/boards/edit/${board.board_id}`}
            data-gd-click="button_click"
            data-button-name="整理"
            data-content-source="未整理的采集"
            ref={sortBtnRef}
          >
            <HBButton> 整理 </HBButton>
          </Link>
        )}
      </div>
      <div className={styles.content} data-content-source="未整理的采集">
        <BoardPinList
          board={board}
          hasPinCreated={board.user_id === user?.user_id}
        />
      </div>
    </div>
  );
}
